import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  IconButton,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { StrapiConfig } from "../../utils/Setting";

const ImageGallery = ({ 
  images, 
  imageOrder, 
  onImageOrderChange, 
  onRemoveImage 
}) => {
  const handleImageOrderClick = (imageId, order) => {
    onImageOrderChange(imageId, order);
  };

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
        Project Images
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
        Images are automatically ordered by upload sequence (1st uploaded = order 1, 2nd = order 2, 3rd = order 3). You can manually change the order by clicking the numbers below. Only the first 3 images will be displayed in your portfolio.
      </Typography>
      <Grid container spacing={2}>
        {images.map((image, index) => (
          <Grid item xs={6} sm={4} md={3} key={index}>
            <Card sx={{ position: 'relative' }}>
              <CardMedia
                component="img"
                height="120"
                image={(() => {
                  if (image.url && image.url.startsWith('http')) {
                    return image.url;
                  } else if (image.url) {
                    return `${StrapiConfig.url}${image.url}`;
                  } else if (image.formats?.thumbnail?.url) {
                    return image.formats.thumbnail.url.startsWith('http') 
                      ? image.formats.thumbnail.url 
                      : `${StrapiConfig.url}${image.formats.thumbnail.url}`;
                  } else if (image.formats?.small?.url) {
                    return image.formats.small.url.startsWith('http') 
                      ? image.formats.small.url 
                      : `${StrapiConfig.url}${image.formats.small.url}`;
                  }
                  return '';
                })()}
                alt={`Project image ${index + 1}`}
                sx={{ objectFit: 'cover' }}
                onError={(e) => {
                  console.error('Image load error for:', image);
                  console.log('Tried URL:', e.target.src);
                }}
              />
              
              {/* Delete Button */}
              <Box sx={{ 
                position: 'absolute', 
                top: 8, 
                right: 8
              }}>
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => onRemoveImage(index)}
                  sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    width: 28,
                    height: 28,
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)',
                    }
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>

              {/* Order Selection Section */}
              <Box sx={{ p: 1.5, pt: 1 }}>
                <Typography variant="caption" sx={{ 
                  display: 'block', 
                  mb: 1, 
                  color: '#666', 
                  fontWeight: 500,
                  textAlign: 'center'
                }}>
                  Display Order
                </Typography>
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'center',
                  gap: 1 
                }}>
                  {/* Order Buttons */}
                  {[1, 2, 3].map((order) => (
                    <Box
                      key={order}
                      onClick={() => handleImageOrderClick(image.id, order)}
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: '50%',
                        backgroundColor: imageOrder[image.id] === order ? '#4D6BF6' : 'transparent',
                        color: imageOrder[image.id] === order ? 'white' : '#6B7280',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        border: imageOrder[image.id] === order ? '2px solid #4D6BF6' : '1px solid #D1D5DB',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          backgroundColor: imageOrder[image.id] === order ? '#3B5BDB' : '#F3F4F6',
                          borderColor: imageOrder[image.id] === order ? '#3B5BDB' : '#9CA3AF',
                          transform: 'scale(1.05)'
                        }
                      }}
                    >
                      {order}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ImageGallery;
